import { is4xxStatus } from './AlertMessageLogic'

export default function messageOnLogin(status) {
    let message

    if (is4xxStatus(status)) status = '4xx'

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos entrar.'
            break
        case '4xx':
            message = 'Usuário ou senha incorretos, revise para continuar.'
            break
        default:
            message =
                'Ops! Algo estranho aconteceu e não está sendo possível realizar o login. Por favor, tente novamente mais tarde.'
    }
    return message
}
